export default "__VITE_ASSET__CJTLH$TG__"